<template>
    <a-modal
        title="选择客户群"
        :width="700"
        :visible="visible"
        wrapClassName="group_select"
        @ok="toCheck"
        @cancel="toCancel"
    >
        <div class="group_search main_center cross_center" style="margin-bottom: 15px;">
            <a-form layout="inline">
                <a-form-item label="群名称">
                    <a-input
                        v-model="searchData.groupName"
                        placeholder="请输入群名称"
                        allowClear
                        @change="groupNameChange"
                    />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="search('warp_search')">搜索</a-button>
                </a-form-item>
                <a-form-item>
                    <a-button type="link"  @click="showSearch = true">更多>></a-button>
                </a-form-item>
            </a-form>
        </div>
        <a-table
            :columns="columns"
            :data-source="dataList"
            :pagination="pagination"
            :loading="loading"
            :row-key="(record) => record.id"
            :scroll="{ y: 306 }"
            @change="tableChange"
        >
            <template slot="action" slot-scope="record">
                <a-radio checked @change="select([record.id])" v-if="record.isSelected"></a-radio>
                <a-radio @change="select([record.id])" v-else></a-radio>
            </template>
            <template slot="name" slot-scope="text, record">
                <div class="btn" @click="select([record.id])">{{ text }}</div>
            </template>
            <template slot="number" slot-scope="text, record">
                <div class="btn" @click="select([record.id])">{{ text }}</div>
            </template>
            <template slot="owner" slot-scope="text, record">
                <div @click="select([record.id])">
                    <openData class="btn" type="userName" :openid="record.owner"></openData>
                </div>
            </template>
            <template slot="createTime" slot-scope="text, record">
                <div class="btn" @click="select([record.id])">{{ text }}</div>
            </template>
        </a-table>
        <contactsModal
            ref="contacts"
            :title="['选择群主', '已选择的群主']"
            type="single"
            :selectKey="searchData.owner"
            @change="contactsChange"
        ></contactsModal>
        <a-modal
            title="搜索"
            :visible="showSearch"
            wrapClassName="group_search"
            :footer="null"
            @cancel="showSearch = false"
        >
            <a-form>
                <a-form-item label="群名称">
                    <a-input
                        v-model="searchData.groupName"
                        placeholder="群名称"
                        allowClear
                        @change="groupNameChange"
                    />
                </a-form-item>
                <a-form-item label="群主">
                    <a-button @click="toOpenContacts" v-if="searchData.owner.length === 0">
                        请选择
                    </a-button>
                    <a-select
                        mode="multiple"
                        v-model="searchData.owner"
                        :open="false"
                        :max-tag-count="2"
                        placeholder="请选择"
                        allow-clear
                        v-else
                        @click.native="toOpenContacts"
                        @change="contactsChange"
                    >
                        <a-select-option v-for="item in searchData.owner" :key="item">
                            <openData type="userName" :openid="item"></openData>
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="创建时间">
                    <a-range-picker
                        v-model="dateTime"
                        allow-clear
                        @change="dateTimeChange"
                    ></a-range-picker>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="search">搜索</a-button>
                </a-form-item>
            </a-form>
        </a-modal>
    </a-modal>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
import openData from '@/components/group/openData';
import contactsModal from '@/components/group/contactsModal';
export default {
    // 选择企业微信群组件
    name: 'group_select',
    props: {
        selectKey: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        openData,
        contactsModal
    },
    data() {
        return {
            visible: false,
            loading: false,
            showSearch: false,
            showDetail: false,
            dateTime: [],
            pagination: {
                total: 0,
                pageSize: 10
            },
            searchData: {
                page: 1,
                owner: []
            },
            columns: [
                {
                    scopedSlots: { customRender: 'action' },
                    width: 50
                },
                {
                    title: '群名称',
                    key: 'name',
                    dataIndex: 'name',
                    scopedSlots: { customRender: 'name' }
                },
                {
                    title: '群人数',
                    key: 'number',
                    dataIndex: 'number',
                    scopedSlots: { customRender: 'number' }
                },
                {
                    title: '群主',
                    key: 'owner',
                    scopedSlots: { customRender: 'owner' }
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    width: 150,
                    dataIndex: 'createTime',
                    scopedSlots: { customRender: 'createTime' }
                },
            ],
            dataList: [],
            selectKeys: {}
        };
    },
    methods: {
        open() {
            this.search();
            this.selectKeys = this.selectKey;
            this.visible = true;
        },
        // 搜索
        async search(type) {
            if (type === 'warp_search') this.searchData.owner = [];
            this.showSearch = false;
            this.loading = true;
            let data = {};
            data.page = this.searchData.page;
            if (this.searchData.groupName) data.groupName = this.searchData.groupName;
            if (this.searchData.owner.length > 0) data.owner = this.searchData.owner;
            if (this.searchData.startTime) data.startTime = this.searchData.startTime;
            if (this.searchData.endTime) data.endTime = this.searchData.endTime;
            try {
                const res = await api.postGroupSearch(data);
                if (res.code !== 0) return;
                this.loading = false;
                this.pagination.total = res.count;
                this.pagination.pageSize = res.pageSize;
                res.rows.forEach((item) => {
                    item.isSelected = false;
                    return item;
                });
                this.dataList = res.rows;
            } catch (err) {
                console.log(err);
            }
        },
        toCheck() {
            this.$emit('change', this.selectKeys);
            this.toCancel();
        },
        toCancel() {
            this.visible = false;
            this.selectKeys = {};
        },
        tableChange(pagination) {
            this.searchData.page = pagination.current;
            this.search();
        },
        groupNameChange(e) {
            if (e.target.value) {
                this.searchData.groupName = e.target.value;
            } else {
                delete this.searchData.groupName;
                this.search();
            }
        },
        select(record) {
            this.dataList.forEach((item) => {
                record.forEach(recItem => {
                    if (item.id === recItem) {
                        item.isSelected = !item.isSelected;
                        if (item.isSelected) this.selectKeys = {
                            name: item.name,
                            chatId: item.chatId
                        };
                        else this.selectKeys = {};
                    } else {
                        item.isSelected = false;
                    }
                    return item;
                })
            });
        },
        // 弹框
        toOpenContacts() {
            this.$refs.contacts.open();
        },
        dateTimeChange(date, dateString) {
            if (_.compact(dateString).length > 0) {
                this.searchData.startTime = dateString[0];
                this.searchData.endTime = dateString[1];
            } else {
                delete this.searchData.startTime;
                delete this.searchData.endTime;
                this.search();
            }
        },
        contactsChange(e) {
            if (e) {
                this.searchData.owner = e;
            } else {
                delete this.searchData.owner;
                this.search();
            }
            console.log(this.searchData);
        }
    }
};
</script>

<style scoped>
.group_select .btn {
    cursor: pointer;
}
</style>
